<!-- 课堂知识点 -->
<template>
    <div>
      <div class="course_knowledgePoints">
        <el-row>
          <el-input v-model="searchInfo.knowledgePointTitle" style="width: 200px;" prefix-icon="el-icon-search" placeholder="知识点检索"></el-input>
          <label style="margin-left: 20px;">练习章节：</label>
          <el-select clearable v-model="searchInfo.chapterId" filterable placeholder="请选择">
            <template v-for="(item ,index) in homeCourseList">
              <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
            </template>
          </el-select>
          <label style="margin-left: 20px;">实操项目：</label>
          <el-select clearable v-model="searchInfo.bussinessId" filterable placeholder="请选择">
            <template v-for="(item ,index) in practicalTrainingList">
              <el-option :label="item.handsOnName" :value="item.handsOnId"></el-option>
            </template>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getInfo">查询</el-button>
        </el-row>
        <el-row class="content_block mt20">
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="knowledgePointTitle" header-align="center" align="center" label="知识点名称" width="150"> </el-table-column>
              <el-table-column prop="knowledgePointContent" header-align="center" align="left" label="知识点内容">
                <template slot-scope="scope">
                  <div v-html="scope.row.knowledgePointContent"></div>
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseIdText" header-align="center" align="center" label="归属课程" width="200"> </el-table-column>
              <el-table-column prop="chapterIdText" header-align="center" align="center" label="归属章节" width="200"> </el-table-column>
              <el-table-column prop="handsOnIdText" header-align="center" align="center" label="归属实操项目" width="200"> </el-table-column>
              <!-- <el-table-column prop="cz" header-align="center" align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <el-link type="primary" class="mr10" :underline="false" @click="editInfo(scope.row)">编辑</el-link>
                  <el-link type="danger" :underline="false" @click="delInfo(scope.row)">删除</el-link>
                </template>
              </el-table-column> -->
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>
import RichText from '@/components/RichText/index';
import {getCourseInfoList,getPracticalTraining} from "@/common/getInfo";	//加载数据
export default {
  name: 'KnowledgePoints',
  components: {
    RichText
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      options: [], //分页搜索条件 章节
      options1: [], //实操信息
      value: '',
      value1: '',
      searchInfo:{
        bussinessId:""
      },
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      courseInfoList:[],
      courseList:[],
      homeCourseList:[],
      practicalTrainingList:[],
    }
  },
  created() {
    this.getInfo();
    this.getHomeCourseList();
    this.getPracticalTraining();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
      }
      param = Object.assign(param,this.searchInfo);
      this.$post("/api/teacherOpenCourseKnowledgePoint/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getHomeCourseList(){
      getCourseInfoList({teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          this.homeCourseList = ret.data;
        }
      });
    },
    getPracticalTraining(){ //获取项目信息
      getPracticalTraining({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级项目信息
        if(ret.code == 0){
          this.practicalTrainingList = ret.data;
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_knowledgePoints{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
    .el-transfer-panel{
      width: 280px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/KnowledgePoints.vue